const features = [
  {
    
    
    description:
      "Firstly, we are a licensed and insured local moving company, meaning that you can be at complete peace during your entire moving experience with NW Trucking of NC.",
  },
  {
    
    description:
      "When you choose us to help you relocate, we at NW Trucking of NC will provide you with transparent pricing – including everything needed for a smooth move and no hidden fees whatsoever.",
  },
  {
   
    description:
      "Our movers are background checked, screened, highly vetted, drug tested and prompt – provided with additional training to enable them to excel in every aspect of local moving.",
  },
];

export default function WhyChooseUs() {
  return (
    <section className="w-full px-6 md:px-10 lg:px-20 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-10 lg:gap-20">
          {/* Text column */}
          <div className="w-full lg:w-[52%] space-y-6">
            <div className="space-y-3">
              <p className="text-[11px] font-semibold tracking-[0.35em] text-foreground-400 uppercase">
                CHOOSE THE BEST
              </p>
              <h2 className="text-[1.75rem] md:text-[2rem] lg:text-[2.4rem] font-extrabold text-foreground-900 leading-tight">
                Why choose us
              </h2>
              <p className="text-[0.9rem] text-foreground-500 leading-relaxed">
                Moving with NW Trucking of NC means moving
                comfortably – which is why you should contact us for a free moving
                quote today.
              </p>
            </div>

            <div className="space-y-6">
              {features.map((feature) => (
                <div key={feature.title} className="flex gap-4 items-start">
                  <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center">
                    <img
                      src={feature.icon}
                      alt={feature.title}
                      className="w-6 h-6 object-contain"
                      width={24}
                      height={24}
                      onError={(e) => {
                        const target = e.currentTarget as HTMLImageElement;
                        target.style.display = "none";
                      }}
                    />
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-foreground-900 mb-1">
                      {feature.title}
                    </h4>
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="pt-2">
              <a
                href="/contact-us"
                className="inline-block px-8 py-2.5 bg-accent-500 text-white font-semibold text-sm rounded-full hover:bg-accent-600 transition-colors whitespace-nowrap"
              >
                GET A QUOTE
              </a>
            </div>
          </div>

          {/* Image column */}
          <div className="w-full lg:w-[48%] relative">
            <svg className="absolute -top-4 -right-4 w-20 h-20 opacity-15 pointer-events-none" viewBox="0 0 80 80">
              <circle cx="40" cy="40" r="34" fill="none" stroke="#7c3aed" strokeWidth="2" strokeDasharray="5 6"/>
            </svg>
            <svg className="absolute bottom-4 -left-4 w-14 h-14 opacity-15 pointer-events-none" viewBox="0 0 70 70">
              <path d="M10,60 C20,25 45,45 60,10" fill="none" stroke="#c74461" strokeWidth="2.5" strokeLinecap="round"/>
            </svg>
            <img
                          src="/images/h2.jpg"
              alt="Professional movers at work"
              className="w-full h-auto rounded-xl object-cover"
              width={900}
              height={675}
            />
          </div>
        </div>
      </div>
    </section>
  );
}